import { gql } from '@apollo/client'

export const SABRE_GET_CATEGORIES = gql`
  query Categories($input: CategoriesInput) {
    categories(input: $input) {
      count
      hasMore
      results {
        id
        name
        parent {
          id
          name
        }
      }
    }
  }
`
